import { Box, Button, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { MobileHelpTooltipStlyes } from '../../styles/HelpToolTip';
import { Close } from '@mui/icons-material';
import { HelpPageProps } from '../../interfaces/HelpToolTip';
import { useTranslation } from 'react-i18next';
import { LayoutStyles } from '../../styles/mfsTheme';
import useHiddenHeaderFooter from '../../hooks/useHiddenHeaderFooter';
import { useAppSelector } from '../../../store/hook';
import { WCAGStrandardStyles } from '../../../common/styles/WCAGStandardStyles';

const CompetencyMobileHelpToolTip = ({
  open,
  setOpen,
  competencyName,
  competencyDesc,
}: HelpPageProps): React.JSX.Element => {
  const { selectedTheme } = useAppSelector((state) => state.headerOptions);
  const { classes } = MobileHelpTooltipStlyes({ selectedTheme: selectedTheme });
  const { classes: contClass } = LayoutStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  useHiddenHeaderFooter(open && !smUp ? contClass.screenContainer : contClass.container);
  const { classes: WCAGClasses } = WCAGStrandardStyles();

  const closeHelp = (): void => {
    setOpen(false);
  };

  return (
    <Box className={`${classes.root} ${classes.compRoot}`}>
      <div className={classes.headingBox}>
        <Typography className={`${classes.headingText} ${WCAGClasses.h4}`}>{competencyName}</Typography>
        <IconButton className={classes.closeBtn} onClick={closeHelp} role="button" aria-label={t('close')}>
          <Close fontSize="large" className={classes.contrastColor} />
        </IconButton>
      </div>
      <Typography className={classes.compDesc}>{competencyDesc}</Typography>
      <Box className={classes.closeBtnBox}>
        <Button className={classes.closeBtn2} onClick={closeHelp} variant="contained">
          {t('ok')}
        </Button>
      </Box>
    </Box>
  );
};

export default CompetencyMobileHelpToolTip;
